import { FormValidationHelpers } from './formValidation.helpers'

export const FormValidations = {
  ...FormValidationHelpers,
}
